module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser !== null) ? _c('div', {
    staticClass: "inbox"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Feedback a Fluxers"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "contenidoPagina",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Pendientes ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedPendientes.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes Feedbacks pendientes aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedPendientes), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.owner,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex-xsmall": "100",
      "md-flex-small": "50",
      "md-flex-medium": "50",
      "md-align": "center"
    }
  }, [_c('main', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Enviados ")]), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.feedFinalizados.length === 0 && !_vm.loader) ? _c('p', [_vm._v("No tienes Feedbacks finalizados aun")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feedFinalizados), function(feed) {
    return _c('div', {
      key: feed.key
    }, [_c('feedback', {
      attrs: {
        "feedback": feed,
        "fluxer": feed.owner,
        "texto": _vm.getTitle(feed)
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser == null) ? _c('div', [_vm._v("\n    el currentUser es null!!\n  ")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button espontaneo md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.openSelectFluxer('selectFluxer')
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Dar feedback espontaneo")])], 1), _vm._v(" "), _c('feedback-companion', {
    ref: "selectFluxer",
    attrs: {
      "isEspontaneo": true,
      "currentFluxer": _vm.currentFluxer[0]
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f7638b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inbox.vue
// module id = 372
// module chunks = 1